import React from 'react';
import './ServicePages.css';

const LlmPage = ({ onContactClick }) => {
  const features = [
    { icon: "🧠", title: "Custom LLM Training", desc: "Train large language models on your proprietary data for domain-specific understanding and accuracy." },
    { icon: "⚡", title: "Model Optimization", desc: "Quantize, prune, and distill models for faster inference without sacrificing quality." },
    { icon: "🔧", title: "Fine-Tuning Services", desc: "Fine-tune open-source models (LLaMA, Mistral, etc.) on your use case for production-ready performance." },
    { icon: "🏗️", title: "Infrastructure Setup", desc: "Set up GPU clusters, model serving infrastructure, and auto-scaling for production LLM workloads." },
    { icon: "🛡️", title: "Safety & Guardrails", desc: "Implement content filtering, prompt injection protection, and output validation for safe AI." },
    { icon: "📐", title: "Evaluation & Benchmarking", desc: "Rigorous evaluation frameworks to measure accuracy, bias, toxicity, and performance of your models." }
  ];

  return (
    <div className="service-page theme-llm">
      <section className="svc-hero">
        <div className="svc-hero-content">
          <h1 className="svc-hero-title">LLM<br/>Development</h1>
          <p className="svc-hero-subtitle">BUILD, FINE-TUNE & DEPLOY LARGE LANGUAGE MODELS.</p>
          <p className="svc-hero-desc">From custom training to production deployment — we build enterprise-grade LLM solutions tailored to your domain and data.</p>
          <div className="svc-hero-stats">
            <div className="svc-stat-item"><h3>99.5%</h3><p>Model Accuracy</p></div>
            <div className="svc-stat-item"><h3>{'<100ms'}</h3><p>Inference Latency</p></div>
            <div className="svc-stat-item"><h3>10B+</h3><p>Parameters Managed</p></div>
          </div>
          <div className="svc-hero-cta">
            <button className="svc-btn-primary" onClick={onContactClick}>Book a Call</button>
            <button className="svc-btn-secondary"><span>▶</span> See Demo</button>
          </div>
        </div>
        <div className="svc-hero-visual">
          <div className="svc-glowing-ring">🧠</div>
        </div>
      </section>

      <section className="svc-features-section">
        <h2 className="svc-section-title">LLM Development Services</h2>
        <div className="svc-features-grid">
          {features.map((f, i) => (
            <div key={i} className="svc-feature-card">
              <div className="feature-icon">{f.icon}</div>
              <h3 className="feature-title">{f.title}</h3>
              <p className="feature-desc">{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="svc-cta-section">
        <div className="svc-cta-content">
          <h2>Ready to build your own LLM?</h2>
          <p>Book a call and we'll discuss your requirements and design a custom LLM strategy.</p>
          <button className="svc-btn-cta" onClick={onContactClick}>Book a Call</button>
        </div>
      </section>
    </div>
  );
};

export default LlmPage;
